export default __webpack_public_path__ + "static/media/iphone8_mockup.c7929dce.png";